module.exports = __webpack_public_path__ + "img/exercises.813cbc73.png";